export default "__VITE_PUBLIC_ASSET__e1022a04__"